/**
 * 功能描述：在 webview 里，js 通过调用 callapp 方法即可调用原生 app 功能
 * @param {String} handlerName 必填，处理器的名称
 * @param {Object} args 非必填，传给处理器的参数，用 Object 格式传入
 * @param {String} callback 非必填, 处理器完成相应的功能后需要回调的 webview 的函数的名称或者一个匿名函数
 */
import hbhbrowser from "hbhbrowser";
function callapp(handlerName, params, callback) {
    if (callback === void 0) { callback = ""; }
    var args = JSON.stringify(params) || "";
    var isIOS = hbhbrowser.isIOS;
    var isAndroid = hbhbrowser.isAndroid;
    var isApp = hbhbrowser.isApp;
    // if not in the app, return
    if (!isApp) {
        return;
    }
    if (isIOS) {
        window.webkit.messageHandlers.ios.postMessage({
            handler: handlerName,
            args: args,
            callback: callback,
        });
    }
    if (isAndroid) {
        hapj_hybrid.android(handlerName, args, callback);
    }
}
export default callapp;
